module.exports = __webpack_public_path__ + "ea67e531e2b0d9a359550c184ab43676.png";